// extracted by mini-css-extract-plugin
export default {"container":"tu3Hw4c6edm4eJ_CSj6g","brand":"EDQR7DuHKUoO_3_85UkS"};